module.exports = __webpack_public_path__ + "static/media/trough-pictogram.13d1a913.svg";